import { useStore as useAiPromptsStore } from './ai-prompts';
import { useStore as useArticlesStore } from './articles';
import { useStore as useArticlesAnalysisStore } from './articles-analysis';
import { useStore as useArticlesFunnelsStore } from './articles-funnels';
import { useStore as useBrandsStore } from './brands';
import { useStore as useBulkGroupsStore } from './bulk-groups';
import { useStore as useMediaStore } from './media';
import { useStore as useNotificationsStore } from './notifications';
import { useStore as useOrganizationBillingStore } from './organization-billing';
import { useStore as useOrgUsersStore } from './organization-users';
import { useStore as useOrganizationsStore } from './organizations';
import { useStore as useProductSectionsStore } from './product-sections';
import { useStore as useProductsStore } from './products';
import { useStore as useUIKeyValueStore } from './ui-key-value';
import { setClearStores, useStore as useUsersStore } from './users';

// TanStack Query hooks (new pattern - migrate to these)
export * from './users-queries';
export * from './organization-billing-queries';
export * from './organizations-queries';
export * from './organization-users-queries';
export * from './articles-queries';
export * from './articles-analysis-queries';
export * from './articles-funnels-queries';
export * from './products-queries';
export * from './product-sections-queries';
export * from './bulk-groups-queries';
export * from './media-queries';
export * from './brands-queries';
export * from './ai-prompts-queries';
export * from './product-template-queries';
export * from './system-config-queries';

const stores = {
  aiPrompts: useAiPromptsStore,
  articles: useArticlesStore,
  articlesAnalysis: useArticlesAnalysisStore,
  articlesFunnels: useArticlesFunnelsStore,
  organizationUsers: useOrgUsersStore,
  organizations: useOrganizationsStore,
  bulkGroups: useBulkGroupsStore,
  brands: useBrandsStore,
  notifications: useNotificationsStore,
  organizationBilling: useOrganizationBillingStore,
  users: useUsersStore,
  products: useProductsStore,
  productSections: useProductSectionsStore,
  uiKeyValue: useUIKeyValueStore,
  mediaStore: useMediaStore,
};

export function getStores() {
  return stores;
}

export function clearStores() {
  const storeKeys = Object.keys(stores);
  for (let i = 0; i < storeKeys.length; i += 1) {
    const key = storeKeys[i] as keyof typeof stores;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const store:
      | {
          clearStore?: () => void;
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        }
      | undefined = stores[key] as any;
    if (store?.clearStore == null) {
      continue;
    }

    store.clearStore();
  }
}

// we don't want to incurr in circular dependency, as such, we need the method to go through
// after in a dynamic fashion. users can't import index.ts directly otherwise it might break
// the import path. we do this to avoid dynamic and circular dependency issues
setClearStores(clearStores);
